// extracted by mini-css-extract-plugin
module.exports = {"storesLayout":"StoresPage_storesLayout__4gsPm"};